exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-production-js": () => import("./../../../src/pages/production.js" /* webpackChunkName: "component---src-pages-production-js" */),
  "component---src-pages-redemption-1-js": () => import("./../../../src/pages/redemption1.js" /* webpackChunkName: "component---src-pages-redemption-1-js" */)
}

